export default "__VITE_ASSET__hNVOAXWT__"